
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 3a1 1 0 011-1h6a1 1 0 01.894 1.447L14.118 5l.776 1.553A1 1 0 0114 8H9v1.83c.279.12.54.296.768.524L14 14.586l1.232-1.232a2.5 2.5 0 013.536 0L21.414 16A2 2 0 0122 17.414V20a2 2 0 01-2 2H4a2 2 0 01-2-2v-4.586A2 2 0 012.586 14l3.646-3.646c.228-.228.49-.403.768-.525V3z"}})])
          )
        }
      }
    